import $ from 'jquery';
import { getFirestore, collection, addDoc } from "@firebase/firestore";
import { initializeApp } from 'firebase/app';

// Initialize Firebase
var firebaseConfig = {
    apiKey: "AIzaSyBkTqfhHeW8gklWthFf7hUi7eolW9TS6NU",
    authDomain: "stoick-site-web.firebaseapp.com",
    projectId: "stoick-site-web",
    storageBucket: "stoick-site-web.appspot.com",
    messagingSenderId: "104857114596",
    appId: "1:104857114596:web:b65ec22b2fdc9d876119f1",
    measurementId: "G-QX26LFSWBT"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);


$("#contactForm").on("submit", function (event) {
    if (event.isDefaultPrevented()) {
        // handle the invalid form...
        formError();
        submitMSG(false, "");
    } else {
        // everything looks good!
        event.preventDefault();
        submitForm();
    }
});


async function submitForm(){

    // Initiate Variables With Form Content
    var firstname = $("#firstname").val();
    var lastname = $("#lastname").val();
    var email = $("#email").val();
    var phone = $("#phone").val() || null;
    var profil = $("#profil").val();
    var message = $("#message").val();
    
    const data = {
        'firstname' : firstname.trim(),
        'lastname' : lastname.trim(),
        'email' : email.trim().toLowerCase(),
        'profil' : profil,
        'phone' : phone,
        'message' : message,
        'createdAt' : new Date()
    };

    try {
        await addDoc(collection(db, "messages"), data);
        formSuccess();
    }
    catch(e) {
        console.log(e);
        formError();
        submitMSG(false, "Un problème est survenu, merci de réessayer.");
    }
}

function formSuccess(){
    $("#contactForm")[0].reset();
    submitMSG(true, "Merci pour votre message, on vous recontacte au plus vite!")
}

function formError(){
    $("#contactForm").removeClass().addClass('shake animated').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass();
    });
}

function submitMSG(valid, msg){
    if(valid){
        var msgClasses = "col-12 h4 text-center fadeInRight animated text-success mt-5 mb-5";
    } else {
        var msgClasses = "col-12 h4 text-center text-danger mt-5 mb-5";
    }
    $("#msgSubmit").removeClass().addClass(msgClasses).text(msg);
    setTimeout(() => $("#msgSubmit").text(""), 5000);
}